// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"8745":"DesignGallery","9690":"OTAPage","9786":"@/features/editor/shell/EditorShell"}[chunkId] || chunkId) + ".css";
};